//@ts-nocheck
import {Component, Inject, Vue, Watch} from 'vue-property-decorator';
import {email, minLength, required} from 'vuelidate/lib/validators';
import * as serviceApi from "@/apis/service";
import * as paymentApi from "@/apis/payment";
import * as codeBy from "@/methods/getCodeByState";
import * as service from "@/methods/service";
import {DateTime} from "luxon";
import RegistrationService from "@/apis/registration";
import {login} from "@/apis/service";

const validations = {
	fullName: { required },
	address: { required },
	cardNumber: { required },
	phoneNumber: { required, minLength: minLength(14) },
	email: { required, email },
	cardFullName: { required },
	cvv: { required },
	material: { required },
	bin: { required },
	cartExpirationDate: { required },
}

export function formatDateString(dateString: string): string {  // return yyyy/mm/dd
	return `${dateString.substr(0, 4)}/${dateString.substr(4, 2)}/${dateString.substr(6, 2)}`
}

@Component({
	validations
})

export default class paymentComponents extends Vue {
	@Inject('registrationService') private registrationService!: () => RegistrationService;

	dessert: any = {};

	public testField: string = '';
	public testField2: string = '';

	dialog: boolean = false

	public terms: string = '';

	public phoneNumber: string = '';
	public fullName: string = '';
	public firstName: string = '';
	public lastName: string = '';
	public email: string = '';
	public typeOfPayment: string = 'creditCard';
	public agree: string = '';
	public monthMask = function(value: any) {
		return ([/[0-1]/, value.charAt(0) === '1' ? /[0-2]/ : /[0-9]/, '/' , /[0-9]/,/[0-9]/]);
	};

	public cardNumber = null;
	public cartExpirationDate: string = '';
	public cvv = null;

	payFormValid = true;

	objectIDContact = '';
	countDays = 0;

	promoCode = '';

	objectIDClient = '';

	materials = [];
	material = [];

	bins = [];
	bin = '';

	jobId = '';
	priceItemTotal = 0;

	priceItem = {};
	priceItemDay = {};

	jobID = null;

	locationId = '';

	newPrice = null;
	discount = null;
	promoID = null;
	tax = 0;

	error = '';
	errorPromo = null

	public cardFullName: string = '';
	public cardFirstName: string = '';
	public cardLastName: string = '';

	public isOpenCard = false

	get displayHours() {
		return this.$store.getters.displayHours
	}
	get displayMinutes() {
		return this.$store.getters.displayMinutes
	}
	get displaySeconds() {
		return this.$store.getters.displaySeconds
	}
	get displayDays() {
		return this.$store.getters.displayDays
	}

	get address() {
		return `${this.$store.getters.address}`
	}

	get checkСondition() {
		const otherMaterial = this.material.find((el) => {
			return el.optionID === 10417
		})
		return !!otherMaterial;
	}

	get addressInput() {
		if(this.$store.getters.country[0]){
			return `${this.$store.getters.address} ${this.$store.getters.city} ${this.$store.getters.stateCountry.toUpperCase()} ${this.$store.getters.postcode} ${this.$store.getters.country[0].toUpperCase() + this.$store.getters.country.slice(1)}`
		}
	}

	get priceWithTax() {
		return (this.priceItemTotal + (this.priceItemTotal * this.priceItem.taxPercent) / 100).toFixed([2])
	}

	openCard() {
		this.isOpenCard = true
	}

	@Watch('fullName')
	watchFullName() {
		var fullName = this.fullName.split(' ')
		this.firstName = fullName[0]
		this.lastName = fullName[fullName.length - 1];
	}

	@Watch('cardFullName')
	watchCardFullName() {
		var fullName = this.cardFullName.split(' ')
		this.cardFirstName = fullName[0]
		this.cardLastName = fullName[fullName.length - 1];
	}

	@Watch('displaySeconds')
	watchDisplayTime() {
		if (this.displaySeconds === "00" &&
			this.displayMinutes === "00" &&
			this.displayHours === "00" &&
			this.displayDays === "00") {
			this.$router.push({ name: "Home" });
			this.$store.commit("clearStore");
		}
	}

	async enterCode() {
		this.newPrice = null;
		this.discount = null;
		this.errorPromo = null;
		const requestData = {
			securityToken: this.$store.getters.token,
			method: 1,
			promo: this.promoCode,
		};
		this.$store.commit('setOverlay', true)
		const response = await serviceApi.checkPromotion(requestData);
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.errorPromo = true
		} else {
			if (data.Promo && data.Promo.length !== 0 && data.Promo[0].isActive === true &&
				data.ClientTypes && data.ClientTypes.length !== 0 &&
				data.ClientTypes.some((el: any) => el.clientTypeID === 1) && data.Franchises &&
				data.Franchises.length !== 0 &&
				data.Franchises.some((el: any) => el.franchiseID == this.$store.getters.franchiseID)) {
				const promoDiscount = data.Promo[0].promoDiscount;
				const promoMeasure = data.Promo[0].promoMeasure;
				this.promoID = data.Promo[0].promoID;
				if (this.priceItem.value && promoDiscount) {
					if (promoMeasure === 'amount') {
						const promoPrice = this.priceItemTotal - promoDiscount
						this.tax = promoPrice * this.priceItem.taxPercent
						this.newPrice = (promoPrice + this.tax / 100).toFixed([2])
						this.discount = promoDiscount
					}
					if (promoMeasure === 'percent') {
						const promoPrice = (this.priceItemTotal * (100 - parseInt(promoDiscount)) / 100)
						this.tax = promoPrice * this.priceItem.taxPercent
						this.newPrice = (promoPrice + this.tax / 100).toFixed([2])
						this.discount = ((this.priceItemTotal * parseInt(promoDiscount)) / 100).toFixed([2])
					}
				}
				this.errorPromo = false
				this.$store.commit('setOverlay', false)
			}
			else {
				this.$store.commit('setOverlay', false)
				this.errorPromo = true
			}
		}
	}

	async loadSomeData() {
		this.$store.commit('setOverlay', true)
		const token = this.$store.getters.token;
		const response = await serviceApi.getOptions(token);
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.$store.commit('setOverlay', false)
			this.error = errMsg
			throw new Error(errMsg);
		} else {
			if (data.Options && data.Options.length !== 0) {
				this.materials = data.Options.filter((el: any) => el.fieldID === 10596 && el.isActive === true)
				this.bins = data.Options.filter((el: any) => el.fieldID === 10595 && el.isActive === true)
			}
			else {
				this.$store.commit('setOverlay', false)
				this.error = 'can not find options'
				throw new Error('can not find options');
			}
		}

		try {
			const priceItem = await service.loadPriceItems()
			this.priceItemDay = priceItem.priceItemDay
			this.priceItem = priceItem.priceItem
			this.priceItemTotal = priceItem.priceItem.value
			this.$store.commit('setOverlay', false)
		} catch (e) {
			this.$store.commit('setOverlay', false)
			this.error = e.message;
			throw new Error(e.message);
		}
	}

	editBin(){
		this.$router.push({ name: "secondStep" });
	}

	async mounted() {
		await this.loadSomeData()
		if(this.$store.getters.clientId){
			const contact = await this.registrationService().getAContactsDetails();
			if ('errNo' in contact && contact.errNo !== 0) {
				let errMsg = 'errMsg' in contact ? contact.errMsg : 'Service is unavailable';
				if (contact.Errors && contact.Errors.length) {
					const [firstError] = contact.Errors;
					({ errMsg } = firstError);
				}
				this.$store.commit('setOverlay', false)
				throw new Error(errMsg);
			}
			else {
				contact.Fields.forEach((field: { fieldID: number; fieldValue: string; }) => {
					if (field.fieldID === 9795) {
						this.fullName = field.fieldValue;
					}
				})
			}

		}
		this.dessert = {
			deliveryDate: formatDateString(this.$store.getters.deliveryDate),
			pickUpDate: formatDateString(this.$store.getters.pickUpDate),
			size: "",
			img: "",
		}
		const date1 = DateTime.fromJSDate(new Date(this.dessert.deliveryDate))
		const date2 = DateTime.fromJSDate(new Date(this.dessert.pickUpDate))

		this.countDays = date2.diff(date1, 'days').toObject().days;
		if(this.countDays - 7 > 0){
			this.priceItemTotal = this.priceItem.value + this.priceItemDay.value * (this.countDays - 7)
		}

		switch (Number(this.$store.getters.serviceID)) {
			case 173:
				this.dessert.size = "mini";
				this.dessert.img = "container1.png";
				break;
			case 174:
				this.dessert.size = "small";
				this.dessert.img = "container2.png";
				break;
			case 175:
				this.dessert.size = "medium";
				this.dessert.img = "container3.png";
				break;
			case 176:
				this.dessert.size = "large";
				this.dessert.img = "container4.png";
				break;
			default:
				break;
		}

		const servicesTypesData = {
			securityToken: this.$store.getters.token,
		};

		const response = await serviceApi.servicesTypes(servicesTypesData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.error = errMsg
			throw new Error(errMsg);
		} else {
			data.ServiceTypes.forEach((el:any)=> {
				if (el.serviceTypeID === 11){
					this.terms = el.tos
				}
			})
		}
	}

	public async createCleint(method:any) {
		const createClientData = {
			securityToken: this.$store.getters.token,
			email: this.email,
			fullName: this.fullName,
			method: +method,
			phoneNumber: this.phoneNumber.replace(/[\s\-\(\)]+/g , '')
		};
		if(+method === 2) {
			createClientData.objectID = this.objectIDClient
		}
		const response = await serviceApi.createClient(createClientData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			this.error = errMsg
			throw new Error(errMsg);
		} else {
			if (data.Client) {
				this.objectIDClient = data.Client.objectID;
			}
			else {
				throw new Error('can not create client');
			}
		}
	}

	public async createContact(method:any) {
		const requestData = {
			securityToken: this.$store.getters.token,
			phone: this.phoneNumber.replace(/[\s\-\(\)]+/g , ''),
			email: this.email,
			firstName: this.firstName,
			fullName: this.fullName,
			lastName: this.lastName,
			method: +method,
			objectID: +method === 2 ? this.objectIDContact: this.objectIDClient,
		};
		const response = await serviceApi.createContact(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.Contact) {
				this.objectIDContact = data.Contact.objectID;
			}
			else {
				throw new Error('can not create contact');
			}
		}
	}

	public async findContact() {
		const requestData = {
			securityToken: this.$store.getters.token,
			phone: this.phoneNumber.replace(/[\s\-\(\)]+/g , ''),
		};
		const response = await serviceApi.findContactByPhone(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.Contacts && data.Contacts.length !== 0) {
				this.objectIDContact = data.Contacts[0].objectID
				this.objectIDClient = data.Contacts[0].Relations.find((client: any) => client.relationType === 'client').objectID
				await this.findLocationByClient();
				await this.createCleint('2');
				await this.createContact('2');
				await this.saveLocation('2');
			}
			else {
				try {
					await this.createCleint('3');
					await this.createContact('3');
					await this.saveLocation('3');

				} catch (e) {
					throw new Error(e.message);
				}
			}
		}
	}

	public async findLocationByClient() {
		const requestData = {
			securityToken: this.$store.getters.token,
			clientID: this.objectIDClient,
		};
		const response = await serviceApi.findLocationByClient(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.Locations && data.Locations.length !== 0) {
				this.locationId = data.Locations[0].objectID
			}
			else {
				throw new Error('can not create location');
			}
		}
	}

	public async saveLocation(method: any) {
		const country = await codeBy.getCountryCodeByTitle(this.$store.getters.country)
		const state = await codeBy.getStateCodeByTitle(this.$store.getters.stateCountry)
		const requestData = {
			securityToken: this.$store.getters.token,
			objectID: +method === 2 ? this.locationId: this.objectIDClient,
			city: this.$store.getters.city,
			zip: this.$store.getters.postcode,
			address: this.$store.getters.address,
			method: +method,
			country,
			state,
		};
		const response = await serviceApi.saveLocation(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.Location) {
				this.locationId = data.Location.objectID
			}
			else {
				throw new Error('can not create location');
			}
		}
	}

	public async createJob() {
		const requestData = {
			securityToken: this.$store.getters.token,
			clientId: this.objectIDClient,
			summary: 'Online booking. No summary data'
		};
		if (this.promoCode && this.promoID) {
			requestData.promoID = this.promoID
			requestData.promotion = this.promoCode
		}
		const response = await serviceApi.createJob(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.Job) {
				this.jobId = data.Job.jobID
				this.$store.commit('setjobID', this.jobId)
			}
			else {
				throw new Error('can not create job');
			}
		}
	}

	public async createWorkOrder(dataForCreate: any, isCharges: any, count: number, isDeliver: boolean) {
		const requestData = {
			securityToken: this.$store.getters.token,
			jobID: this.jobId,
			lockID: dataForCreate.lockID,
			clientID: this.objectIDClient,
			contactID: this.objectIDContact,
			locationID: this.locationId,
			description: 'Online booking. No summary data',
			Fields: []
		};

		if (isDeliver) {
			requestData.Fields = [
				{
					fieldID: 10596,
					fieldValue: this.material.find((el) => {
						return el.optionID === 10417
					}) !== undefined ? 	this.materials.map((item: any, index: number) => {
						if (index === this.materials.length - 1){
							return item.optionID + '!~!' + item.name + '!`!' + (this.material.indexOf(item) !== -1? '1':'0') + '!!!~~~!!!'
						} else {
							return item.optionID + '!~!' + item.name + '!`!' + (this.material.indexOf(item) !== -1? '1':'0') + '!!~~!!'
						}
					}).join('') + this.testField2 : this.materials.map((item: any, index: number) => {
						if (index === this.materials.length - 1){
							return item.optionID + '!~!' + item.name + '!`!' + (this.material.indexOf(item) !== -1? '1':'0') + '!!!~~~!!!'
						} else {
							return item.optionID + '!~!' + item.name + '!`!' + (this.material.indexOf(item) !== -1? '1':'0') + '!!~~!!'
						}
					}).join('')
				},
				{
					fieldID: 10595,
					optionID: this.bin.optionID
				}
			]

			if ( this.bin.optionID == 10376 ){
				requestData.Fields.push({
					fieldID: 10614,
					fieldValue: this.testField
				})
			}
		}

		if (isCharges) {
			const object = {
				priceItemID: this.priceItem.priceItemID,
				taxID: this.priceItem.taxID,
				sequence: this.priceItem.sequence,
				Fields: [
					{
						fieldID: 9290,
						fieldValue: this.priceItem.defaultDescription
					},
					{
						fieldID: 9289,
						fieldValue: this.priceItem.defaultDescription
					},
					{
						fieldID: 9288,
						fieldValue: "1" // Quantity
					},
					{
						fieldID: 9287,
						fieldValue: this.priceItem.value // Price = value из запроса выше
					}
				]
			}
			requestData.charges = []
		    requestData.charges.push(object)

			if(count && count > 0){
				const objectDay = {
					priceItemID: this.priceItemDay.priceItemID,
					taxID: this.priceItemDay.taxID,
					sequence: this.priceItemDay.sequence,
					Fields: [
						{
							fieldID: 9290,
							fieldValue: this.priceItemDay.defaultDescription
						},
						{
							fieldID: 9289,
							fieldValue: this.priceItemDay.defaultDescription
						},
						{
							fieldID: 9288,
							fieldValue: count // Quantity
						},
						{
							fieldID: 9287,
							fieldValue: this.priceItemDay.value // Price = value из запроса выше
						}
					]
				}
				requestData.charges.push(objectDay)
			}
		}
		const response = await serviceApi.createWorkOrder(requestData)
		const { data } = response;
		if ('errNo' in data && data.errNo !== 0) {
			let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
			if (data.Errors && data.Errors.length) {
				const [firstError] = data.Errors;
				({ errMsg } = firstError);
			}
			throw new Error(errMsg);
		} else {
			if (data.WorkOrder) {
				return
			}
			else {
				throw new Error('can not create workOrder');
			}
		}
	}


	public async payMethod() {
		if (this.$refs.paymentForm.validate()) {
			try {

				this.$store.commit('setOverlay', true)
				await this.findContact()
				const requestData = await this.createProfileAuthorize()
				await this.createJob()
				let charges = true
				await this.createWorkOrder({
					lockID: this.$store.getters.deliveryLockID
				}, charges, this.countDays - 7, true)
				charges = false
				await this.createWorkOrder({
					lockID: this.$store.getters.pickUpLockID
				}, charges, 0, false)
				const requestDataForSavePayment = {
					clientId: this.objectIDClient,
					securityToken: this.$store.getters.token,
					jobID: this.jobId,
					customerProfileId: requestData.customerProfileId,
					paymentProfileId: requestData.paymentProfileId,
					cardNumber: (String(this.cardNumber)).substr(-4),
					transactionId: requestData.transactionId,
					transactionResponse: requestData.transactionResponse,
					amount: this.newPrice ? this.newPrice : this.priceWithTax,
				};
				if (!window.dataLayer) {
					window.dataLayer = [];
				}
				window.dataLayer.push({
					type: "Purchase"
				});


				window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
				const count = this.countDays - 7
				const objStatistic = {
					'ecommerce': {
						'purchase': {
							'actionField': {
								'id': requestDataForSavePayment.transactionId,
								'affiliation': 'Online Store',
								'revenue': this.newPrice ? this.newPrice : this.priceWithTax,
								'tax': this.newPrice ? this.tax : (this.priceItemTotal * this.priceItem.taxPercent) / 100,
								'shipping': '0',
								'coupon': this.promoCode
							},
							'products': [{
								'name': this.priceItem.priceItem,
								'id': this.priceItem.priceItemID,
								'price': this.priceItem.value,
								'quantity': 1,
							}]
						}
					}
				}
				if ( count > 0 ) {
					objStatistic.ecommerce.purchase.products.push({
						'name': this.priceItem.priceItem,
						'id': this.priceItem.priceItemID,
						'price': this.priceItemDay.value,
						'quantity': count,
					})
				}
				window.dataLayer.push(objStatistic);

				await paymentApi.savePayment(requestDataForSavePayment)
				this.$store.commit('setOverlay', false)
				this.$store.commit('setFourthStepComplited');
				this.$router.push({ name: 'finish', params: {} })
			} catch (e) {
				this.error = e.message;
				this.$store.commit('setOverlay', false)
				throw new Error(e.message);
			}
		}
	}

	public async createProfileAuthorize() {
		this.cardNumber = this.cardNumber.replace(/\s+/g, '');
		const requestDataForAuthorize = {
			clientId: this.objectIDClient,
			email: this.email,
			firstName: this.cardFirstName,
			lastName: this.cardLastName,
			address: this.address,
			city: this.$store.getters.city,
			state: this.$store.getters.stateCountry,
			postalCode: this.$store.getters.postcode,
			phone: this.phoneNumber.replace(/[\s\-\(\)]+/g , ''),
			cardNumber: this.cardNumber,
			cardCode: Number(this.cvv),
			expirationDate: this.cartExpirationDate,
		};

		const authorizeResponse = await paymentApi.createCustomerProfileAuthorize(requestDataForAuthorize)
		if(authorizeResponse.messages && authorizeResponse.messages.resultCode && authorizeResponse.messages.resultCode === 'Error'){
			throw new Error('This transaction has been declined.  Transaction failed');
		}
		const { customerProfileId } = authorizeResponse;
		if (!customerProfileId
			|| !authorizeResponse.customerPaymentProfileIdList
			|| !authorizeResponse.customerPaymentProfileIdList.length) {
			throw new Error('This transaction has been declined.  Transaction failed');
		}

		const paymentProfileId = authorizeResponse.customerPaymentProfileIdList[0];

		const requestDataForAuthorizePay = {
			customerProfileId: customerProfileId,
			paymentProfileId: paymentProfileId,
			amount: this.newPrice ? this.newPrice : this.priceWithTax,
			// amount: 1,
			serviceName: this.dessert.size,

		};

		const authorizePayResponse = await paymentApi.sendPaymentAuthorize(requestDataForAuthorizePay)
		const { transactionResponse } = authorizePayResponse;
		if((authorizePayResponse.messages && authorizePayResponse.messages.resultCode && authorizePayResponse.messages.resultCode === 'Error') || (authorizePayResponse.transactionResponse  && authorizePayResponse.transactionResponse.errors && authorizePayResponse.transactionResponse.errors.length) ){
			throw new Error('This transaction has been declined.  Transaction failed');
		}
		if (transactionResponse.transId) {
			return  {
				customerProfileId: customerProfileId,
				paymentProfileId: paymentProfileId,
				transactionId: transactionResponse.transId,
				transactionResponse: transactionResponse,
			};
		} else {
			this.error = 'This transaction has been declined.  Transaction failed'
			throw new Error('This transaction has been declined.  Transaction failed');
		}
	}
}
